import { render, staticRenderFns } from "./aboutoursmessage.vue?vue&type=template&id=0fc12254&scoped=true&"
import script from "./aboutoursmessage.vue?vue&type=script&lang=js&"
export * from "./aboutoursmessage.vue?vue&type=script&lang=js&"
import style0 from "./aboutoursmessage.vue?vue&type=style&index=0&id=0fc12254&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc12254",
  null
  
)

export default component.exports